module.exports = __webpack_public_path__ + "static/media/moons_cuanto_cuestan-1500.2c5ffded.jpg";